// extracted by mini-css-extract-plugin
export default {"footer":"tablePagination_footer__BdKgD","paging":"tablePagination_paging__PuDZL","totalRecords":"tablePagination_totalRecords__QpykF"};